import React, { useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withUAPLThemedStyles } from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

import { InfoIcon, BlueInfoIcon } from './icons';

const getAdInfoLabelStyles = () => ({
  adInfoLabelContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  infoIcon: {
    width: 12,
    height: 12,
    color: 'rgba(43, 43, 43, 0.53)',
  },
  adInfoText: {
    fontSize: 12,
    weight: 400,
    lineHeight: '16px',
    color: 'rgba(43, 43, 43, 0.8)',
    marginLeft: 4,
  },
});

const AdInfoLabelImpl = ({ showAdText, adInfoLabelClassName, classes }) => {
  const i18n = useContext(I18nContext);

  return (
    <div
      className={classNames(
        classes.adInfoLabelContainer,
        adInfoLabelClassName,
        'ad-info-label-container'
      )}
    >
      <div className={classNames(classes.infoIcon, 'info-icon')}>
        {showAdText ? <InfoIcon /> : <BlueInfoIcon />}
      </div>
      {showAdText && (
        <div className={classNames(classes.adInfoText, 'ad-info-text')}>
          {i18n.getString(_TL_('Ad'))}
        </div>
      )}
    </div>
  );
};

AdInfoLabelImpl.propTypes = {
  showAdText: PropTypes.bool,
  adInfoLabelClassName: PropTypes.string,
  classes: PropTypes.shape({
    adInfoLabelContainer: PropTypes.string,
    infoIcon: PropTypes.string,
    adInfoText: PropTypes.string,
  }).isRequired,
};

AdInfoLabelImpl.defaultProps = {
  showAdText: true,
  adInfoLabelClassName: undefined,
};

export const AdInfoLabel = withUAPLThemedStyles(
  AdInfoLabelImpl,
  getAdInfoLabelStyles,
  { componentName: 'AdInfoLabel' }
);
